/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GetBudgetResponse = {
    status: string;
    message: string;
    body: {
        budget_id: string;
        facility_id: string;
        facility_name: string;
        group_id: string;
        group_name: string;
        division_id: string;
        division_name: string;
        created_by_user_id: string;
        budget_type: GetBudgetResponse.budget_type;
        budget_currency: string;
        budget_name: string;
        sales_included: boolean;
        production_included: boolean;
        production_units: Array<{
            id: string;
            name: string;
            value: number;
        }>;
        budget_map: Array<{
            dates_column: string;
            budget_data: {
                commodity_ids: Array<{
                    id: string;
                    name: string;
                    cost: number;
                    usage: number;
                    usage_uom: Record<string, any>;
                }>;
                production_units_ids: Array<{
                    id: string;
                    name: string;
                    value: number;
                }>;
                sales?: Array<{
                    id: string;
                    cost: number;
                }>;
            };
        }>;
        start_date: string;
        end_date: string;
        commodity_names: Array<string>;
        commodity_ids: Array<string>;
        created_at: string;
        updated_at: string;
    };
};

export namespace GetBudgetResponse {
    export enum budget_type {
        ANNUALLY = 'Annually',
        QUARTERLY = 'Quarterly',
        MONTHLY = 'Monthly',
    }
}
